import React, { useEffect, useState } from 'react'
import { Container, FieldBox } from '../../common/formParts/FieldPartsStyled'
import Select from 'react-select'
import DatetimeField from './DateTimeField'
import ConfirmModal from "./ConfirmModal";

const EasyNewsForm = (props) => {
  const [easyNewsTypes, setEasyNewsTypes] = useState(props.easy_news_types)
  const [categories, setCategories] = useState([])
  const [categoryDetails, setCategoryDetails] = useState([])

  let initCategorySelected = null
  let initCategoryDetailSelected = null

  if (props.easy_news.id) { // Edit mode
    // get category label where category id is props.easy_news_category_id
    const category = props.easy_news_categories.filter(
      (category) => parseInt(category.id) === parseInt(props.easy_news.easy_news_category_id)
    )
    initCategorySelected = { label: category[0].name, value: props.easy_news.easy_news_category_id }

    // get category detail label where category detail id is props.easy_news_category_detail_id
    const categoryDetail = props.easy_news_category_details.filter(
      (categoryDetail) => parseInt(categoryDetail.id) === parseInt(props.easy_news.easy_news_category_detail_id)
    )
    initCategoryDetailSelected = { label: categoryDetail[0].name, value: props.easy_news.easy_news_category_detail_id }
  }
  const [selectedCategory, setSelectedCategory] = useState(initCategorySelected)
  const [selectedCategoryDetail, setSelectedCategoryDetail] = useState(initCategoryDetailSelected)
  const [title, setTitle] = useState(props.easy_news.title || '')
  const [easyNewsType, setEasyNewsType] = useState(props.easy_news.easy_news_type_id || easyNewsTypes[0].id)

  const getAllCategoriesForType = (type_id) => {
    const categoriesForType = props.easy_news_categories.filter(
      (category) => parseInt(category.type_id) === parseInt(type_id)
    )
    const uniqueCategories = categoriesForType.filter(
      (category, index, self) => index === self.findIndex((t) => (
        t.name === category.name
      ))
    )
    setCategories(uniqueCategories)
  }

  const getCategoryDetailForSelectedCategory = (category_id) => {
    const categoryDetailsForCategory = props.easy_news_category_details.filter(
      (categoryDetail) => parseInt(categoryDetail.category_id) === parseInt(category_id)
    )
    setCategoryDetails(categoryDetailsForCategory)
  }

  useEffect(() => {
    if (categoryDetails.length === 1 && categoryDetails[0].name === '-') {
      getCategoryDetailDescription(categoryDetails[0].id)
      setSelectedCategoryDetail({ label: categoryDetails[0].name, value: categoryDetails[0].id })
    }
  }, [categoryDetails])


  const getCategoryDetailDescription = (category_detail_id) => {
    const categoryDetail = props.easy_news_category_details.filter(
      (categoryDetail) => parseInt(categoryDetail.id) === parseInt(category_detail_id)
    )
    const description = categoryDetail[0].description.body
    const display_name = categoryDetail[0].display_name
    setTitle(display_name)
    // For Rich Editor:
    // in description, replace all \n with <br> and set it to the rich editor
    document.getElementById('easy_news_details').value = description.replace(/\n/g, '<br>')
    document.getElementById('easy_news_details').style.backgroundColor = '#fff'
    document.getElementById('easy_news_details').contentEditable = true
    document.getElementById('easy-news-confirm-modal').disabled = false
  }

  const resetRichEditor = () => {
    document.getElementById('easy_news_details').value = 'カテゴリ、カテゴリ詳細を選択してください'
    document.getElementById('easy_news_details').contentEditable = false
    document.getElementById('easy_news_details').style.backgroundColor = '#f2f2f2'
    document.getElementById('easy-news-confirm-modal').disabled = true
  }

  const resetInputs = () => {
    setSelectedCategory('')
    setSelectedCategoryDetail('')
    setTitle('')
    resetRichEditor()
  }

  const handleChangeType = (e) => {
    resetInputs()
    setEasyNewsType(e.target.value)
    getAllCategoriesForType(e.target.value)
  }

  const onChangeSelectCategory = (e) => {
    getCategoryDetailForSelectedCategory(e.value)
    setSelectedCategoryDetail('')
    setSelectedCategory({ label: e.label, value: e.value })
    setTitle('')
    resetRichEditor()
  }

  const onChangeSelectCategoryDetail = (e) => {
    setSelectedCategoryDetail({ label: e.label, value: e.value })
    getCategoryDetailDescription(e.value)
  }

  useEffect(() => {
    if (!props.easy_news.id) {
      // console.log('NEW MODE')
      getAllCategoriesForType(easyNewsTypes[0].id)
      resetRichEditor()
    } else {
      // console.log('EDIT MODE')
      getAllCategoriesForType(easyNewsType)
    }
  }, [])

  // Modal confirmation
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [renderModal, setRenderModal] = useState(0)
  const confirmButton = document.getElementById('easy-news-confirm-modal')

  confirmButton.addEventListener('click', (e) => {
    e.preventDefault()
    setIsModalVisible(true)
    setRenderModal(renderModal + 1)
  })


  return(
    <Container>
      <div className="field-unit easy_news" key={"easy_news_type"}>
        <div className="field-unit__label field-unit--required">
          <label htmlFor="easy_news_type">お知らせタイプ</label>
        </div>
        <div className="field-unit__field">
          <div id={"easy_news_type"}>
            <FieldBox>
              { easyNewsTypes.map((type) => {
                return(
                  <>
                    <input
                      type="radio"
                      name="easy_news[easy_news_type_id]"
                      id={"type_"+type.id}
                      value={type.id}
                      onChange={handleChangeType}
                      checked={easyNewsType == type.id}
                    />
                    <label htmlFor={"type_"+type.id}>{type.description}</label>
                  </>
                )
                })
              }
            </FieldBox>
          </div>
        </div>
      </div>
      <div className="field-unit easy_news" key={"easy_news_category"}>
        <div className="field-unit__label field-unit--required">
          <label htmlFor="easy_newsdetail">カテゴリ</label>
        </div>
        <div className="field-unit__field">
          <div id="easy_news_category">
            <div>
              <Select
                key={"select-category"}
                value={selectedCategory}
                placeholder={'ここから選択'}
                options={
                  categories && categories.map((category, index) => ({
                    label: category.name,
                    value: category.id,
                    key: index
                  }))
                }
                onChange={(e) => {
                  onChangeSelectCategory(e)
                }}
                name={"easy_news[easy_news_category_id]"}
                // isClearable={true}
                // isSearchable={true}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        key={"easy_news_category_detail"}
        className={
          (categoryDetails.length === 1 && categoryDetails[0].name === '-') ||
          (selectedCategoryDetail != null && selectedCategoryDetail.label == '-') ? 'field-unit easy_news blank' : 'field-unit easy_news'}
      >
      {
        (categoryDetails.length === 1 && categoryDetails[0].name === '-') ||
        (selectedCategoryDetail != null && selectedCategoryDetail.label == '-') ? (
        <></>
        ):(
          <div className="field-unit__label field-unit--required">
            <label htmlFor="easy_news_category_detail">カテゴリ詳細</label>
          </div>
        )}
        <div className="field-unit__field">
          <div id="easy_news_category_detail">
              { (categoryDetails.length === 1 && categoryDetails[0].name === '-') ||
                (selectedCategoryDetail != null && selectedCategoryDetail.label == '-') ? (
                <input type="hidden" name="easy_news[easy_news_category_detail_id]" value={(selectedCategoryDetail != null && selectedCategoryDetail.value) || (categoryDetails != 'undefined' ? categoryDetails[0].id : '')} />
              ) : (
                <div>
                  <Select
                    key={"select-category"}
                    value={selectedCategoryDetail}
                    placeholder={'ここから選択'}
                    options={
                      categoryDetails && categoryDetails.map((category, index) => ({
                        label: category.name,
                        value: category.id,
                        key: index
                      }))
                    }
                    onChange={(e) => {
                      onChangeSelectCategoryDetail(e)
                    }}
                    name={"easy_news[easy_news_category_detail_id]"}
                    isDisabled={(selectedCategory !== null && selectedCategory !== '') ? false : true}
                    // isClearable={true}
                    // isSearchable={true}
                  />
              </div>
              )}
          </div>
        </div>
      </div>

      <div className="field-unit easy_news" key={"easy_news_title"}>
        <div className="field-unit__label field-unit--required">
          <label htmlFor="easy_news_title">タイトル </label>
        </div>
        <div className="field-unit__field">
          <input
            type="text"
            id="easy_news_title"
            name="easy_news[title]"
            value={title}
            onChange={(e)=>setTitle(e.target.value)}
            disabled={(selectedCategoryDetail !== null && selectedCategoryDetail !== '') ? false : true}
          />
        </div>
      </div>

      <div className="field-unit easy_news" key={"easy_news_schedule"}>
        <div className="field-unit__label field-unit--required">
          <label htmlFor="easy_news_schedule">日時</label>
        </div>
        <div className="field-unit__field">
          <div id="easy_news_schedule">
            <DatetimeField {...props} />
          </div>
        </div>
      </div>
      <ConfirmModal key={renderModal} isVisible={isModalVisible} {...props} selectedNewsType={easyNewsType} />
    </Container>
  )
}

export default EasyNewsForm
